<div class="wrapper-promotions">
    <div class="section-title row">
        <div class="section-btn">
            <button class="btn btn-back" routerLink="/dashboard/discounts" [attr.aria-label]="'Back' | translate">
              <i class="fi-rr-arrow-alt-left"></i>
            </button>
        </div>
        <div>
            <div class="title" [attr.data-parent]="'Automatic Discounts' | translate">Add Discount</div>
        </div>
    </div>

    <div class="section-main mt-4">
        <div class="table-stores table-responsive mx-auto px-4 pt-3 pb-5" style="overflow-y: hidden;">
            <form>

                <div class="d-flex flex-column col-12 col-lg-12 mt-4">
                    <!-- <label class="form-label">Select Voucher</label> -->
                    <h4 class="title-2 mt-2">Select Voucher</h4>
                    <div ngbDropdown class="d-inline-block row">
                        <div class="row ml-0">
                            <div class="col-12 col-lg-6">
                                <i class="arrow down"></i>
                                <button *ngIf="!selectedVoucer" id="dropdownBasic1" ngbDropdownToggle class="btn btn-outline-primary text-left w-100">&nbsp;</button>
                                <button *ngIf="selectedVoucer" class="btn btn-outline-primary text-left w-100" id="dropdownBasic1" ngbDropdownToggle aria-expanded="false" >
                                    {{ selectedVoucer }}
                                </button>
                            </div>
                            <div class="col-12 col-lg-6">
                                <button class="btn btn-blue-small ml-3 mt-1 mb-5" (click)="addDiscount(selectedVoucerId)">Save</button>
                                <button class="btn btn-red-small ml-3 mt-1 mb-5" (click)="backToList()">Cancel</button>
                            </div>
                        </div>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="col-12 col-lg-6">
                            <!-- <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown dropdown-menu"> -->
                                <button *ngFor="let voucher of voucherList" ngbDropdownItem (click)="selectVoucher(voucher.product_name, voucher.p_id, i)">
                                    <img width="40" [src]="voucher.image">
                                    <span class="ml-2">{{ voucher.product_name }}</span>
                                </button>
                            <!-- </div> -->
                        </div>
                        
                    </div>
                </div>
    
                
            </form>
        </div>
    </div>
</div>

<ng-template #success let-modal>
    <div class="modal-body text-center">
        <div class="row" align="center" >
            <div class="col pt-4 pt-lg-0">
                <h4>Successfully Update</h4>
            </div>
        </div>
        <button  class="btn btn-primary" type="button" name="button" (click)="modal.close('Send click')  ">Close</button>
    </div>
</ng-template>
